import type { SectionLocale } from '../types'

export const I18N_PREFIX_TYPE = 'transactions_type_'
export const I18N_PREFIX_STATUS = 'transactions_status_'

export const TRANSACTIONS_LOCALE: SectionLocale = [
  [
    'transactions_export_log',
    {
      ru: 'Экспорт журнала',
      en: 'Export log',
    },
  ],
  [
    'transactions_export_log_error',
    {
      ru: 'Ошибка экспорта журнала. Пожалуйста, повторите позже',
      en: 'Failed to export the log. Please try again later',
    },
  ],
  // [
  //   'transactions_type_billing_period_change',
  //   {
  //     ru: 'Изменение расчётного периода',
  //     en: 'Billing period change',
  //   },
  // ],
  [
    'transactions_type_all',
    {
      ru: 'Все типы',
      en: 'All types',
    },
  ],
  [
    'transactions_type_purchase',
    {
      ru: 'Покупка',
      en: 'Purchase',
    },
  ],
  [
    'transactions_type_transfer',
    {
      ru: 'Перевод',
      en: 'Transfer',
    },
  ],
  [
    'transactions_type_deposit',
    {
      ru: 'Системное начисление',
      en: 'System deposit',
    },
  ],
  [
    'transactions_type_admin_credit',
    {
      ru: 'Админское начисление',
      en: 'Admin credit',
    },
  ],
  [
    'transactions_type_admin_debit',
    {
      ru: 'Админское списание',
      en: 'Admin debit',
    },
  ],
  [
    'transactions_type_refund',
    {
      ru: 'Возврат',
      en: 'Refund',
    },
  ],
  [
    'transactions_table_no_data',
    {
      ru: 'Журнал транзакций пуст',
      en: 'The transaction log is empty',
    },
  ],
  [
    'transactions_table_col_date_and_time',
    {
      ru: 'Дата',
      en: 'Date',
    },
  ],
  [
    'transactions_table_col_id',
    {
      ru: 'ID',
      en: 'ID',
    },
  ],
  [
    'transactions_table_col_user',
    {
      ru: 'Пользователь',
      en: 'User',
    },
  ],
  [
    'transactions_table_col_comment',
    {
      ru: 'Комментарий',
      en: 'Comment',
    },
  ],
  [
    'transactions_table_col_transaction_type',
    {
      ru: 'Тип транзакции',
      en: 'Transaction type',
    },
  ],
  [
    'transactions_table_col_transaction_id',
    {
      ru: 'ID транзакции',
      en: 'Transaction ID',
    },
  ],
  [
    'transactions_table_col_order_id',
    {
      ru: 'Номер заказа',
      en: 'Order ID',
    },
  ],
  [
    'transactions_table_col_amount',
    {
      ru: 'Сумма',
      en: 'Amount',
    },
  ],
  [
    'transactions_table_col_related_object',
    {
      ru: 'Связанный объект',
      en: 'Related object',
    },
  ],
  [
    'transactions_table_col_order_status',
    {
      ru: 'Статус',
      en: 'Status',
    },
  ],
  [
    'transactions_status_create',
    {
      ru: 'Ожидает подтверждения',
      en: 'Create',
    },
  ],
  [
    'transactions_status_waits_for_confirmation',
    {
      ru: 'Ожидает подтверждения',
      en: 'Waiting For Confirmation',
    },
  ],
  [
    'transactions_status_confirmed',
    {
      ru: 'Подтверждён',
      en: 'Confirmed',
    },
  ],
  [
    'transactions_status_cancelled',
    {
      ru: 'Отменён',
      en: 'Cancelled',
    },
  ],
  [
    'transactions_status_fulfilled',
    {
      ru: 'Отправлен',
      en: 'Fulfilled',
    },
  ],
  [
    'transactions_status_completed',
    {
      ru: 'Доставлен',
      en: 'Completed',
    },
  ],
  [
    'transactions_status_shipped',
    {
      ru: 'В пути',
      en: 'Shipped',
    },
  ],
  [
    'transactions_table_rows_per_page',
    {
      ru: 'Записей на странице',
      en: 'Records per page',
    },
  ],
  [
    'transactions_pagination_show_records',
    {
      ru: 'Показать {count} записей',
      en: 'Show {count} records',
    },
  ],
  [
    'transactions_transaction_details',
    {
      ru: 'Детали транзакции',
      en: 'Transaction details',
    },
  ],
]
